export interface FaqEntry {
  readonly question: string;
  readonly answer: string;
}

export const FAQ_ENTRIES: Array<FaqEntry> = [
  {
    question: 'Jak wygląda pierwsza wizyta u fizjoterapeuty?',
    answer: `Pierwsza wizyta w moim gabinecie w Gliwicach to kompleksowa konsultacja. Składa się z rozmowy na temat
             Twoich dolegliwości, analizy dokumentacji medycznej oraz badania funkcjonalnego, ortopedycznego lub
             neurologicznego. Dzięki temu mogę dokładnie ocenić problem i opracować plan leczenia dostosowany do Twoich
             potrzeb.`
  },
  {
    question: 'Ile kosztuje wizyta u fizjoterapeuty?',
    answer: `Cena wizyty zależy od rodzaju terapii i jej długości. W moim gabinecie oferuję konkurencyjne ceny oraz
             indywidualne podejście do każdego pacjenta. Szczegółowy cennik znajdziesz po kliknięciu przycisku Booksy
             lub możesz zapytać telefonicznie.`
  },
  {
    question: 'Kiedy warto udać się do fizjoterapeuty?',
    answer: `Fizjoterapeuta może pomóc przy wielu dolegliwościach, takich jak ból pleców, rwa kulszowa, urazy sportowe,
             ograniczenia ruchowe czy rehabilitacja po operacji. Jeśli odczuwasz ból lub dyskomfort, nie zwlekaj – im
             szybciej zaczniemy terapię, tym lepsze efekty możemy osiągnąć.`
  },
  {
    question: 'Czy potrzebuję skierowania do fizjoterapeuty?',
    answer: `W moim gabinecie w Gliwicach nie potrzebujesz skierowania – możesz umówić się na wizytę bezpośrednio. Jeśli
             jednak posiadasz dokumentację medyczną (np. wyniki badań obrazowych), warto ją zabrać, by lepiej dopasować
             terapię.`
  },
  {
    question: 'Jak długo trwa rehabilitacja u fizjoterapeuty?',
    answer: `Czas rehabilitacji zależy od rodzaju problemu, stopnia jego zaawansowania oraz Twoich indywidualnych
             potrzeb. Zazwyczaj leczenie obejmuje kilka wizyt, ale dokładny plan ustalimy podczas pierwszej konsultacji.`
  },
  {
    question: 'Jakie dokumenty zabrać na wizytę u fizjoterapeuty?',
    answer: `Warto przynieść wyniki badań obrazowych (np. RTG, MRI) oraz wcześniejsze diagnozy, jeśli je posiadasz.
             Przydatny będzie też wygodny strój umożliwiający swobodny dostęp do problematycznych obszarów ciała.`
  },
  {
    question: 'Czy fizjoterapia pomaga na specyficzne dolegliwości, np. ból pleców, rwę kulszową?',
    answer: `Tak, fizjoterapia skutecznie pomaga w leczeniu wielu dolegliwości, w tym bólu kręgosłupa, rwy kulszowej,
             urazów sportowych czy problemów ze stawami. Dzięki mojemu doświadczeniu zarówno w pracy ze sportowcami, jak
             i pacjentami indywidualnymi, oferuję metody leczenia dopasowane do każdej sytuacji.`
  },
  {
    question: 'Po czym poznać dobrego fizjoterapeutę?',
    answer: `Dobrego fizjoterapeutę poznasz po indywidualnym podejściu, skutecznych efektach terapii, ciągłym
             dokształcaniu się i dobrych opiniach pacjentów.`
  },
  {
    question: 'Jaka jest różnica między fizjoterapią a rehabilitacją?',
    answer: `Fizjoterapia to część rehabilitacji skupiająca się na leczeniu ruchem i manualnych technikach, natomiast
             rehabilitacja obejmuje szersze działania wspierające powrót do zdrowia, w tym także np. opiekę
             psychologiczną.`
  },
  {
    question: 'Ile trwa zabieg fizjoterapii?',
    answer: `Pojedynczy zabieg fizjoterapii trwa zazwyczaj ok. 60 minut, w zależności od rodzaju schorzenia i
             zastosowanej terapii.`
  },
  {
    question: 'W czym pomaga fizjoterapia?',
    answer: `Fizjoterapia pomaga w leczeniu bólu, poprawie ruchomości stawów, regeneracji po urazach oraz przywracaniu
             sprawności po operacjach.`
  },
  {
    question: 'Co obejmuje fizjoterapia?',
    answer: `Fizjoterapia obejmuje terapię manualną, ćwiczenia lecznicze, masaż, fizykoterapię oraz edukację pacjenta
             dotyczącą prawidłowego ruchu i profilaktyki.`
  },
  {
    question: 'Czy fizjoterapia pomaga na ból kręgosłupa?',
    answer: `Tak, fizjoterapia jest jedną z najskuteczniejszych metod leczenia bólu kręgosłupa, zarówno ostrego, jak i
             przewlekłego.`
  }
];
